import type { YStackProps as BaseStackProps } from "tamagui";
import { XStack, YStack } from "tamagui";

import { getCursor } from "@/utils/cursor.util";

type NormalizedStackProps = Omit<BaseStackProps, "accessibilityLabel">;

interface StackProps extends BaseContainerViewProps, NormalizedStackProps {}

const VStack = ({ accessibilityLabel, testID, ...rest }: StackProps) => {
  return (
    <YStack
      aria-label={accessibilityLabel}
      testID={testID}
      // TODO: these rules are disabled temporarily and will be re-enabled later once upgrade to expo-v53 is done.
      // eslint-disable-next-line react/jsx-props-no-spreading, @typescript-eslint/no-explicit-any,  @typescript-eslint/consistent-type-assertions
      {...(rest as any)}
      cursor={getCursor(rest)}
    />
  );
};

const HStack = ({ accessibilityLabel, testID, ...rest }: StackProps) => {
  return (
    <XStack
      aria-label={accessibilityLabel}
      testID={testID}
      // TODO: these rules are disabled temporarily and will be re-enabled later once upgrade to expo-v53 is done.
      // eslint-disable-next-line react/jsx-props-no-spreading, @typescript-eslint/no-explicit-any,  @typescript-eslint/consistent-type-assertions
      {...(rest as any)}
      cursor={getCursor(rest)}
    />
  );
};

export type { StackProps };
export { HStack, VStack };
